@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.plan-grid-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.plan-container {
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: pointer;
}

.plan-item {
  display: flex;
  place-content: center center;
  flex-direction: column;
  min-height: 38px;
  padding-left: @space-4;
  padding-right: @space-4;

  &:last-child {
    justify-content: flex-start;
    padding: @space-8 0;
  }
}

.plan-price {
  &:extend(.plan-item);
  font-weight: 500;
}

.header-column {
  background-color: @settings-page--subscription-header--background-color;
  flex: 1.3;
  text-align: left;
  cursor: unset;
}

.header-item {
  &:extend(.plan-item);
  padding-left: @space-16;
}

.plan {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-top: 2px solid transparent;
}

.plan-features {
  border: 1px solid @settings-page--subscription-plan-grid--border-color;
  border-left: none;
  height: 100%;
  padding-bottom: 1px;
  padding-left: 1px;
}

.selected {
  border: 2px solid @settings-page--subscription-plan-grid--selected--border-color;

  .plan-features {
    border-bottom: none;
    border-right: none;
    border-left: none;
    padding-bottom: 0;
    padding-left: 0;
  }
}

.selected-icon {
  height: 16px;
  fill: var(--blue-600);
  position: absolute;
}

.recommended-cell {
  min-height: 28px;
  color: @settings-page--subscription-plan-grid--selected--border-color;
  font-weight: 500;

  &.selected {
    color: @settings-page--subscription-modal--background-color;
    background-color: @settings-page--subscription-plan-grid--selected--border-color;
    border: 2px solid @settings-page--subscription-plan-grid--selected--border-color;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
  }
}

.empty {
  background-color: @settings-page--subscription-modal--background-color;
}

.plan-name {
  &:extend(.plan-item);
  font-weight: 600;
  padding-left: 0;
  padding-right: 0;
  position: relative;
}

.select-plan {
  &:extend(.header-item);
  font-size: 20px;
  font-weight: 400;
}
